var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 39.474,
    viewBox: "0 0 45 39.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "love",
    transform: "translate(0 -31.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(19.863 31.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M241.161,31.435a5.6,5.6,0,0,0-4.614,2.414,5.6,5.6,0,0,0-4.614-2.414A6.044,6.044,0,0,0,226,37.707c0,3.761,2.907,6.186,7.306,9.859.749.626,1.546,1.29,2.383,2.007a1.316,1.316,0,0,0,1.715,0c.837-.717,1.634-1.381,2.383-2.007,4.4-3.673,7.306-6.1,7.306-9.859A6.044,6.044,0,0,0,241.161,31.435Z",
    transform: "translate(-226 -31.435)",
    fill: "#4e3057"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(0 55.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M1.318,300.365A1.305,1.305,0,0,0,0,301.683v13.184a1.305,1.305,0,0,0,1.318,1.318H8v-15.82Z",
    transform: "translate(0 -300.365)",
    fill: "#4e3057"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(10.635 51.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M150.741,267.112l-6.2,7.116a3.89,3.89,0,0,1-2.9,1.266H132.76a1.318,1.318,0,0,1,0-2.637h8.016a2.637,2.637,0,1,0,0-5.273h-6.908c-.657,0-.985-.417-1.5-.87a9.327,9.327,0,0,0-7.251-2.241,8.918,8.918,0,0,0-4.113,1.66V283.4h19.775a9.241,9.241,0,0,0,7.383-3.692l6.41-8.437C157.088,267.965,153.03,264.678,150.741,267.112Z",
    transform: "translate(-121 -264.405)",
    fill: "#4e3057"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.d639fc568db59453c6957a16f659b8fa.svg";
export { ForwardRef as ReactComponent };